import { render, staticRenderFns } from "./FieldLabel.vue?vue&type=template&id=2ecd4c41&"
import script from "./FieldLabel.vue?vue&type=script&lang=js&"
export * from "./FieldLabel.vue?vue&type=script&lang=js&"
import style0 from "./FieldLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports